import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';

export const antRoutes: Routes = [
    {
        path: 'dashboard/account-negotiation',
        title: 'Pulse ANT - Home',
        canActivate: [productGuard('ant')],
        loadComponent: () =>
            import('app/products/account-negotiation/dashboards/homepage/account-negotiation.component').then(
                m => m.AntHomePageComponent
            ),
    },
    {
        path: 'dashboard/wishwantwalk-hotel',
        title: 'Wish, Want, Walk for Hotels/RM',
        canActivate: [productGuard('ant')],
        loadComponent: () =>
            import('app/products/account-negotiation/dashboards/wishwantwalk-hotel/wishwantwalk-hotel.component').then(
                m => m.WishWantWalkHotelComponent
            ),
    },
    {
        path: 'dashboard/wishwantwalk-sales',
        title: 'Wish, Want, Walk for Sales',
        canActivate: [productGuard('ant')],
        loadComponent: () =>
            import('app/products/account-negotiation/dashboards/wishwantwalk-sales/wishwantwalk-sales.component').then(
                m => m.WishWantWalkSalesComponent
            ),
    },
];
